import { ww } from "./windowWidth";

export default {
    isInitialised: false,

    options: {
        initWidth: 768,
        maxItems: null,
        selector: '[data-scroll="true"]',
        class: {
            anchor: ['block', 'flex-grow', 'px-3', 'py-5', 'text-white', 'text-center', 'hover:bg-primary', 'lg:text-lg'],
            navBar: ['fixed', 'z-20', 'bottom-0', 'left-0', 'w-full', 'flex', 'bg-gradient-to-r', 'from-primary', 'to-secondary'],
            navBarWrapper: ['wrapper', 'flex']
        },
        id: {
            navBar: "nav-bar-sticky"
        }
    },

    init: function( activateClass ) {
        const self = this;

        // If the activateElement is not present do not run
        if( document.querySelector(activateClass) === null ) {
            return;
        }

        if( ww.getWindowWidth() >= self.options.initWidth ) {
            self.addNavBar();
        }

        // Configure event listeners
        var resizeFinish;
        window.addEventListener( 'resize', function(e) {

            clearTimeout(resizeFinish);

            resizeFinish = this.setTimeout(self.updateStickyNavBarOnResize(self), 100)
        })
    },

    updateStickyNavBarOnResize: function(self) {
        if( ww.getWindowWidth() >= self.options.initWidth ) {
            if( !self.isInitialised ) {
                self.addNavBar();
            } else {
                self.showNavBar();
            }
        } else {
            if( self.isInitialised )
                self.hideNavBar();
        }
    },

    /**
     * Detects all elements matching the defined selector and adds them to 
     * the sticky nav bar
     * 
     */
    addNavBar: function() {
        const self = this;
        const scrollElements = document.querySelectorAll(self.options.selector);

        // 2. create the navbar item and wrapper
        const navBar = document.createElement('nav');
        const navBarWrapper = document.createElement('div');

        if( document.getElementById(self.options.id.navBar) )
            return;
        
        navBar.id = self.options.id.navBar;
        navBar.classList.add(...self.options.class.navBar);
        navBarWrapper.classList.add(...self.options.class.navBarWrapper);
        navBar.appendChild(navBarWrapper);

        // 3. Add the scroll elements to the navbar
        scrollElements.forEach( elem => {
            const anchor = document.createElement('a');
            anchor.setAttribute('href', `#${elem.id}`);
            anchor.classList.add(...self.options.class.anchor);
            anchor.innerHTML = `${elem.id[0].toUpperCase()}${elem.id.slice(1)}`;
            navBarWrapper.appendChild(anchor);
        })
        
        // 4. Add the navbar to the DOM
        document.body.appendChild(navBar);

        self.isInitialised = true;
    },

    showNavBar: function() {
        const self = this;
        const navBar = document.getElementById(self.options.id.navBar);

        navBar.classList.remove('hidden');
    },

    hideNavBar: function() {
        const self = this;
        const navBar = document.getElementById(self.options.id.navBar);

        navBar.classList.add('hidden');
    },
}